<template>
    <div class="container-fluid mb-5">

        <div class="mb-5" v-if="userDetails.affiliate && userDetails.affiliate.affiliate_code">
            <div class="row py-3">
                <div class="col-sm-12 col-md-6">
                    <div class="text-left py-2">
                        <h3>Dashboard</h3>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="text-right">
                        <div class="btn-group">
                         <a v-if="userDetails.affiliate" v-clipboard:copy="'https://app.dukakit.com/'.clipboardCode" v-clipboard:success="onCopy" v-clipboard:error="onError" v-clipboard="'https://app.dukakit.com/' + userDetails.affiliate.affiliate_code" href="#" class="btn btn-primary border-right rounded btn-sm" rel="noopener noreferrer"><i class="bi bi-clipboard"></i>&nbsp;<span>Copy my link</span></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row py-3">
                <div class="col-sm-12 col-md-6">
                    <div class="text-left py-2">
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker" :ranges="false">
                        <template #input="picker" style="width: 100% !important;">
                                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(dateRange.startDate) }}
                                            - {{ FormatDate(picker.endDate) }}</p>
                                        <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
</template>
                    </date-range-picker>

                </div>
        </div>
            <hr />
            <div v-if="hasLoaded===true" class="card">
                <div class="card-body">
                    <div class="row">
                <div class="col-sm-6 col-md-4 border">
                    <div class="py-2 h-100">
                        <div class="text-dark pb-3">
                            <p><i class="bi bi-buildings"></i> Sign ups</p>
                            <hr class="bg-dark m-0 mb-2 mt-1" />

                            <p class="text-dark" ><span class="text-dark text-big"><i class="bi bi-circle-fill"></i></span> All - {{ companiesTable.items.length }}</p>


                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-md-4 border">
                    <div class="py-3 h-100">
                        <div class="text-dark pb-3">
                            <p> <i class="bi bi-cart-check-fill"></i>Earnings</p>
                            <hr class="bg-dark m-0 mb-2 mt-1" />

                            <p class="text-dark" >Total - {{ convertCurrencyToShillings(affiliateCompanies.earnings) }}</p>



                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4 border">
                    <div class="py-3 h-100">
                        <div class="text-dark pb-3" v-if="affiliateCompanies.wallet">
                            <p> <i class="bi bi-wallet"></i> Available Commission</p>
                            <hr class="bg-dark m-0 mb-2 mt-1" />
                            <p class="text-dark" ><span class="text-dark text-big"><i class="bi bi-circle-fill"></i></span> Balance - {{ convertCurrencyToShillings(affiliateCompanies.wallet.amount) }}</p>
                            <div v-if="affiliateCompanies.wallet && affiliateCompanies.wallet.amount > 100">

                            <hr/>
                            <a href="#" v-b-modal.make-mpesa-withdrawal  >Withdraw</a>
                        </div>
                            <hr/>

                            <a href="#">View recent transactions</a>


                        </div>
                    </div>
                </div>
            </div>

                </div>

            </div>
            <div v-else class="card">
                <div class="card-body">
                    <div class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
            <h2 class="pt-3">All Companies</h2>
             <form>
                <div class="form-group">
                    <input class="form-control" v-model="companiesTable.searchTerm" placeholder="Search by company Name" />
                </div>
                </form>


<div class="mb-5">
    <b-table
            sticky-header="100vh"
            @filtered="onFiltered"
            :fields="companiesTable.fields"
            :items="filteredItems"
            :filter="companiesTable.filter"
            striped>
<template #cell(status)="data">

  <div v-if="data.item.is_subscription ===0 && data.item.installation_fee === null">
    <p class="text-danger"><i class="bi bi-circle"></i></p>
  </div>
  <div v-else>
   <p class="text-success"><i class="bi bi-circle"></i></p>
  </div>
</template>
<template #cell(company)="data">

    {{ data.item.company.name }}
</template>
<template #cell(earnings)="data">

    <div v-if="!data.item.is_subscription && !data.item.installation_fee">
   0
  </div>
  <div v-else>
    {{convertCurrencyToShillings(data.item.is_subscription ? data.item.is_subscription: data.item.installation_fee)}}

  </div>
</template>

<template #cell(date_added)="data">
     {{formatDate(data.item.company.created_at, 'hh:mm A DD-MMM-Y')}}
</template>
<template #cell(last_activity)="data">
    <p v-if="data.item.company.user_activity_summary">
        {{ formatDate(data.item.company.user_activity_summary.created_at, 'hh:mm A DD-MMM-Y') }}
    </p>
    <p v-else class="text-danger">
        0 - ACTIVITY
    </p>

</template>


<!--
<template #cell(action)="data">
    <a data-toggle="dropdown" aria-expanded="false"><i class="bi bi-three-dots-vertical"></i></a>
    <div class="dropdown-menu">
        <a class="dropdown-item" :href='"/company-details?company-id=" + data.item.id'>More Details</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="switchToViewAsOwner(data.item.id)" href="#">View as owner</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#">Suspend</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item text-danger" @click="(deleteInventoryConfirm(data.item))">Delete Inventory</a>
    </div>
</template> -->

            </b-table>
            <div class="mb-5"></div>
            <div class="mb-5"></div>
            <div class="mb-5"></div>
</div>



        </div>



    <div v-else>
            <div class="d-flex justify-content-center">
                <div v-if="onboardStep=== 0">
                    <div class="text-center">
                        <small class="text-primary">Step 1/2</small>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Welcome to Dukakit Affiliate program!. </h4>
                        <p>To get started just answer a few quizzes. It's easy as one, two, 10k 💸</p>
                    </div>
                    <button @click="onboardAffiliate" class="btn btn-primary btn-block">Let's get started <i class="bi bi-chevron-right"></i> </button>
                </div>
                <div v-if="onboardStep=== 1">
                    <div class="py-2">
                        <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a>
                    </div>
                    <div class="text-center">
                        <small class="text-primary">Step 2/3</small>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Do you own a business?</h4>
                        <small class="">Are you a business owner currently using Dukakit?</small>
                        <div class="py-2 text-left ml-5">
                            <div class="form-check">
                                <input class="form-radio-input" type="radio" value=0 name="usingDukakit" v-model="onboardingQuizes.usingDukakit">
                                <label class="form-radio-label" for="defaultCheck1">
                            Yes
                            </label>
                            </div>
                            <div class="form-check">
                                <input class="form-radio-input" type="radio" value=1 name="usingDukakit" v-model="onboardingQuizes.usingDukakit">
                                <label class="form-radio-label" for="defaultCheck1">
                               No
                            </label>
                            </div>
                        </div>
                    </div>
                    <button @click="onboardAffiliate" class="btn btn-primary btn-block">Continue <i class="bi bi-chevron-right"></i> </button>
                </div>
                <div v-if="onboardStep=== 2">
                    <div class="py-2">
                        <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a>
                    </div>
                    <div class="text-center">
                        <small class="text-primary">Step 3/3</small>
                        <p v-if="errorMessage !==''" class="text-danger">{{errorMessage}}</p>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Let's pick a friendly link for you</h4>
                        <small class="">Type in the input below</small>
                        <div class="py-2 text-left ml-1">
                            <div class="form-group">
                                <div class="form-inline">
                                    <input class="form-control" style="width: 90%;" type="text" placeholder="Type name" name="username" v-model="onboardingQuizes.userName">
                                    <div v-if="onboardingQuizes.userName !==''">
                                        <span v-if="nameCheck" class="text-success h3"><i class="bi bi-check"></i></span>
                                        <span v-else class="text-danger h3"><i class="bi bi-x"></i></span>
                                    </div>
                                </div>
                            </div>
                            <small class="text-success" v-if="onboardingQuizes.userName !=='' && nameCheck">https:://app.dukakit.com/{{ onboardingQuizes.userName }}</small>
                            <small class="text-danger" v-else-if="onboardingQuizes.userName !=='' && !nameCheck">{{ onboardingQuizes.userName }} has been taken</small>
                        </div>
                    </div>
                    <button @click="onboardFinish" class="btn btn-primary btn-block">Continue to dashboard <i class="bi bi-chevron-right"></i> </button>
                </div>
            </div>
        </div>
      <b-modal id="make-mpesa-withdrawal" ref="makeMpesaWithdrawal" hide-footer>
        <div class="text-center" v-if="!messageToWithdraw && affiliateCompanies.wallet">
            <h4>Withdraw to M-pesa</h4>

            <p>The amount will be sent to your M-pesa number</p>
            <hr />
            <form @submit.prevent="withdrawToMpesa">
                <div class="form-group">
                    <input class="form-control" type="number" placeholder="Enter amount" v-model="amountToWithdraw" />

                </div>
                <div class="form-group">
                    <button v-if="(amountToWithdraw < 5001 && amountToWithdraw > 9) || amountToWithdraw > affiliateCompanies.wallet.amount " class="btn btn-primary">Continue to Withdraw - {{ convertCurrencyToLocal(amountToWithdraw) }}</button>
                    <button v-else class="btn btn-secondary" disabled>Continue to Withdraw</button>
                </div>

            </form>
        </div>
        <div class="text-center" v-else>
            <div class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="py-3" v-html="messageToWithdraw"></p>
        </div>
      </b-modal>
        </div>
    </template>

<script>
    import axios from "axios";
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import {
        mapGetters
    } from 'vuex';
    export default {
        name: "AdminDashboard",
        components: {
            DateRangePicker,
        },
        data() {
            return {
                autoApply: true,
                hasLoaded: false,
                companiesTable: {
                    items: [],
                    fields: [
                        {
                            key: 'status',
                            sortable: false
                        },
                        {

                            key: 'company',
                            sortable: true,
                            filterByFormatted: true
                        },
                        {

                            key: 'earnings',
                            sortable: true
                        },
                        {

                            key: 'date_added',
                            sortable: true
                        },
                        {

                            key: 'last_activity',
                            sortable: true
                        }
                    ],
                    filter: null,
                    totalRows: 1,
                    filterOn: [],
                    searchTerm: '',
                },
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                companies: {},
                users: {
                    all: [],
                    active: []
                },
                onboardStep: 0,
                onboardingQuizes: {
                    usingDukakit: false,
                    userName: '',
                },
                affiliateCompanies:{
                    earnings:0,
                    wallet:{},
                    companies:{}
                },
                companiesStats: {
                    companies: {
                        orders: {},
                        user: {},
                    },
                    activeCompanies: '',
                    inActiveCompanies: '',
                    freemiumCompanies: '',
                    allOrdersCount: '',
                    totalFinalOrderCount: '',
                },
                nameCheck: false,
                errorMessage: "",
                affiliateEarnings: 0,
                amountToWithdraw: 0,
                messageToWithdraw: false,
            }
        },
        mounted() {
            this.getAllCompaniesStats()
            if(this.userDetails.affiliate && this.userDetails.affiliate)
            {


                if(localStorage.getItem("affiliate_onboarding_steps"))
                {
                    localStorage.removeItem("affiliate_onboarding_steps")
                    localStorage.removeItem("affiliate_onboardingresponse")
                    window.location.reload()
                }

            }

            this.companiesTable.totalRows = this.companiesTable.items.length
        },
        watch: {
            "onboardingQuizes.userName": function(before, after) {
                axios.get('/api/check-affiliate-name', {
                    params: {
                        username: this.onboardingQuizes.userName
                    }
                }).then(results => {
                    if (results.data.available === 1) {
                        this.nameCheck = true
                        this.errorMessage = ''
                    } else {
                        this.nameCheck = false
                    }
                }).catch()
            }
        },
        computed: {
            sortOptions() {
                // Create an options list from our fields
                return this.companiesTable.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return {
                            text: f.label,
                            value: f.key
                        }
                    })
            },
            filteredItems() {
                return this.companiesTable.items.filter(item =>
                    item.company.name.toLowerCase().includes(this.companiesTable.searchTerm.toLowerCase())
                );
            },
            ...mapGetters(['userDetails'])
        },
        methods: {
            onboardAffiliate() {
                localStorage.setItem("affiliate_onboarding_steps", parseInt(this.onboardStep + 1))
                localStorage.setItem("affiliate_onboardingresponse", JSON.stringify({ ...this.onboardingQuizes
                }))
                this.getCurrentOnboardStatus()
            },
            onboardFinish() {
                if (this.nameCheck && this.errorMessage === '') {
                    this.errorMessage = ''
                    localStorage.setItem("affiliate_onboardingresponse", JSON.stringify({ ...this.onboardingQuizes
                    }))
                    localStorage.setItem("affiliate_onboarding_steps", parseInt(this.onboardStep + 1))
                    this.getCurrentOnboardStatus()
                    axios.post('/api/onboard-affiliate', {
                        response: (localStorage.onboardingresponse) ? localStorage.onboardingresponse : { ...this.onboardingQuizes
                        }
                    }).then(
                        results => {
                            if(results.status === 200)
                            {
                                window.location.replace('/affiliates')
                            }
                        }
                    ).catch(error => {
                        this.processingMessage = "There was an error creating you account please reload the page ....."
                    })
                } else {
                    this.errorMessage = "There was an error, make sure you have entered a username or the username is available"
                }
            },
            onboardOneStepBack() {
                if (this.onboardStep > 0) {
                    localStorage.setItem("affiliate_onboarding_steps", parseInt(this.onboardStep - 1))
                    this.getCurrentOnboardStatus()
                }
            },
            getCurrentOnboardStatus() {
                this.onboardStep = (localStorage.affiliate_onboarding_steps) ? parseInt(localStorage.affiliate_onboarding_steps) : 0;
            },
            async getAllCompaniesStats() {

                await axios.get('/api/get-affiliates-companies-stats').then(results => {
                    this.affiliateCompanies = results.data

                    this.companiesTable.items = this.affiliateCompanies.companies
                    // this.affiliateEarnings = affiliateCompanies.earnings
                    this.hasLoaded = true

                }).catch(
                    e => {
                        console.log(e)
                    }
                )
            },
            onCopy: function(e) {
                this.copyMessage = 'Copied...'
                this.$toasts.push({
                    'type': 'success',
                    'message': 'Copied successfully'
                })
            },
            onError: function(e) {
                this.$toasts.push({
                    'type': 'error',
                    'message': 'Failed to copy,retry'
                })
            },
            formatDate(date, format) {
                const finaldate = moment(date).format(format);
                return finaldate;
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.companiesTable.totalRows = filteredItems.length
            },
            withdrawToMpesa() {
                axios.post('/api/request-to-withdraw-to-mpesa',{amount:this.amountToWithdraw}).then(results=>{
                    if(results.status === 200 && results.data.type === 'success')
                    {
                        setTimeout(() => {
                            this.messageToWithdraw = "Processing request"
                            window.location.href='/affiliates'
                        }, 3000);

                    }
                    if(results.status === 200 && results.data.type === 'error')
                    {
                       if(results.data.message == "Seems you haven't set an M-pesa phone number. Go to your profile page and update phone number")
                       {
                        this.messageToWithdraw = results.data.message + '&nbsp<a href="/profile">Visit Profile</a>'
                       }
                       else{
                        this.messageToWithdraw = results.data.message
                       }




                    }
                })
            },
        },
    }
</script>
